module.exports = __webpack_public_path__ + "img/Quai-des-pecheurs-quartier-du-Pont-Levis-Sete-900-600.9b47b8ce.png";